import React from 'react';
import { Cell } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/Cell';
import { INumberCellProps } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/NumberCell/type';
import classNames from 'classnames';
import './index.scss';

export const NumberCell = (props: INumberCellProps) => {
  const { className, style, children, config } = props;

  return (
    <Cell className={classNames('dbd-common-table__number-cell', className)} style={style} config={config}>
      {children}
    </Cell>
  );
};
